import { pushDataLayer } from '../index'
import { PageViewLayer } from '@component/dataLayer'

export default function PageViewDataLayer() {

  return (
    <PageViewLayer data={{
      'vertical': 'find an agent',
      'vertical_type': 'real estate offices',
      'page_type': 'detail',
      'event': 'page_view'
    }}></PageViewLayer>
  )
}

export function OfficeListPageViewDataLayer() {

  return (
    <PageViewLayer data={{
      'vertical': 'find an agent',
      'vertical_type': 'real estate offices',
      'page_type': 'search',
      'event': 'page_view'
    }}></PageViewLayer>
  )
}

export const officeDataLayer = {
  listingsTabClick(event, id) {
    pushDataLayer({
      'event': event,
      'office_id': id
    })
  },
}